import React, { useState, useEffect, useRef } from 'react';

const imagePaths: Array<() => Promise<{ default: string }>> = [
  () => import('../assets/customerfeedbackimages/1.jpeg'),
  () => import('../assets/customerfeedbackimages/2.jpeg'),
  () => import('../assets/customerfeedbackimages/3.jpeg'),
  () => import('../assets/customerfeedbackimages/4.jpeg'),
  () => import('../assets/customerfeedbackimages/5.jpeg'),
  () => import('../assets/customerfeedbackimages/6.jpeg'),
  () => import('../assets/customerfeedbackimages/7.jpeg'),
  () => import('../assets/customerfeedbackimages/8.jpeg'),
  () => import('../assets/customerfeedbackimages/9.jpeg'),
  () => import('../assets/customerfeedbackimages/10.jpeg'),
  () => import('../assets/customerfeedbackimages/11.jpeg'),
  () => import('../assets/customerfeedbackimages/12.jpeg'),
  () => import('../assets/customerfeedbackimages/13.jpeg'),
  () => import('../assets/customerfeedbackimages/14.jpeg'),
  () => import('../assets/customerfeedbackimages/15.jpeg'),
  () => import('../assets/customerfeedbackimages/16.jpeg'),
  () => import('../assets/customerfeedbackimages/17.jpeg'),
  () => import('../assets/customerfeedbackimages/18.jpeg'),
];

interface Testimonial {
  imgIdx: number;
  name: string;
  area: string;
  stars: number;
  review: string;
  device: string;
}

const TESTIMONIALS: Testimonial[] = [
  { imgIdx: 0,  name: 'Kunal Sharma',   area: 'Andheri West',  stars: 5, device: 'iPhone 13 Pro',  review: 'Screen was cracked badly. Technician came home, fixed it in 45 mins. Looks brand new. Super impressed!' },
  { imgIdx: 1,  name: 'Rahul Mehta',    area: 'Bandra East',   stars: 5, device: 'iPhone 12',       review: 'Battery was draining in 3 hours. OEM battery replaced at home. Now lasts all day. Great service!' },
  { imgIdx: 2,  name: 'Rohan Patil',    area: 'Dadar',         stars: 5, device: 'iPhone 12',       review: 'Back glass shattered after a drop. Fixed within an hour at my doorstep. Excellent workmanship!' },
  { imgIdx: 3,  name: 'Amit Joshi',     area: 'Borivali',      stars: 5, device: 'iPhone 14',       review: 'Camera was blurry after a fall. Minto replaced it same day. Photos are crystal clear now!' },
  { imgIdx: 4,  name: 'Nikhil Nair',    area: 'Thane',         stars: 5, device: 'Samsung S22',     review: 'Charging port stopped working. Technician diagnosed and fixed it in 30 minutes. Superb!' },
  { imgIdx: 5,  name: 'Kiran Desai',    area: 'Malad',         stars: 5, device: 'iPhone SE',       review: 'Screen replacement done at home. Quality is amazing and price was very affordable!' },
  { imgIdx: 6,  name: 'Arjun Kapoor',   area: 'Powai',         stars: 5, device: 'Samsung S21',     review: 'Display replaced perfectly. Minto is my go-to for phone repairs. Highly recommend!' },
  { imgIdx: 7,  name: 'Deepa Rao',      area: 'Chembur',       stars: 5, device: 'iPhone 14 Plus',  review: 'Battery was swollen. Technician came in 2 hours, replaced safely. Very professional!' },
  { imgIdx: 8,  name: 'Vijay Kumar',    area: 'Kandivali',     stars: 5, device: 'iPhone 13',       review: 'Face ID still works after screen replacement. No one else could do this. Brilliant team!' },
  { imgIdx: 9,  name: 'Anita Singh',    area: 'Goregaon',      stars: 5, device: 'iPhone 11',       review: 'Speaker was muffled. Quick doorstep repair. Sound is crystal clear now. 10/10!' },
  { imgIdx: 10, name: 'Rohit Shah',     area: 'Juhu',          stars: 5, device: 'iPhone 15 Pro',   review: 'Cracked screen on day 2. Minto saved me! Premium quality OLED replacement done fast.' },
  { imgIdx: 11, name: 'Kavya Menon',    area: 'Versova',       stars: 5, device: 'iPhone 12 Pro',   review: 'Water damage repaired expertly. My phone works perfectly again. Amazing technicians!' },
  { imgIdx: 12, name: 'Suresh Iyer',    area: 'Santacruz',     stars: 5, device: 'iPhone 11',       review: 'Old battery was dead. Got OEM battery with 180-day warranty! Very professional team.' },
  { imgIdx: 13, name: 'Meera Patel',    area: 'Mulund',        stars: 5, device: 'iPhone 13 mini',  review: 'Dropped from stairs, screen shattered. Minto fixed it within an hour. Lifesavers!' },
  { imgIdx: 14, name: 'Aakash Verma',   area: 'Vikhroli',      stars: 5, device: 'OnePlus 11',      review: 'Screen replaced at doorstep. Fits perfectly, touch works flawlessly. Very happy!' },
  { imgIdx: 15, name: 'Nisha Gupta',    area: 'Kurla',         stars: 5, device: 'iPhone 13',       review: 'Back glass cracked. Beautiful repair job. Cannot tell it was ever damaged. Wonderful!' },
  { imgIdx: 16, name: 'Sanjay Pillai',  area: 'Worli',         stars: 5, device: 'iPhone 14 Pro',   review: 'Battery health was 71%. Got genuine OEM battery. Now at 100%! Great experience overall.' },
  { imgIdx: 17, name: 'Ritu Agarwal',   area: 'Lower Parel',   stars: 5, device: 'iPad Air',        review: 'iPad screen cracked. Fixed at home in 1.5 hours. Professional, reliable and affordable!' },
];

const CARD_WIDTH = 272;
const CARD_GAP = 12;

const TestimonialMarquee: React.FC = () => {
  const [loadedImages, setLoadedImages] = useState<Record<number, string>>({});
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  const autoScrollRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeftRef = useRef(0);
  const touchStartX = useRef(0);

  useEffect(() => {
    imagePaths.forEach((loader, i) => {
      loader().then((module) => {
        setLoadedImages(prev => ({ ...prev, [i]: module.default }));
      });
    });
  }, []);

  const scrollToIndex = (index: number) => {
    scrollRef.current?.scrollTo({ left: index * (CARD_WIDTH + CARD_GAP), behavior: 'smooth' });
  };

  const resetAutoScroll = () => {
    if (autoScrollRef.current) clearInterval(autoScrollRef.current);
    autoScrollRef.current = setInterval(() => {
      setActiveIndex(prev => {
        const next = (prev + 1) % TESTIMONIALS.length;
        scrollToIndex(next);
        return next;
      });
    }, 4000);
  };

  useEffect(() => {
    resetAutoScroll();
    return () => { if (autoScrollRef.current) clearInterval(autoScrollRef.current); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mouse drag
  const handleMouseDown = (e: React.MouseEvent) => {
    isDragging.current = true;
    startX.current = e.pageX - (scrollRef.current?.offsetLeft ?? 0);
    scrollLeftRef.current = scrollRef.current?.scrollLeft ?? 0;
    if (autoScrollRef.current) clearInterval(autoScrollRef.current);
  };
  const handleMouseMove = (e: React.MouseEvent) => {
    if (!isDragging.current || !scrollRef.current) return;
    e.preventDefault();
    scrollRef.current.scrollLeft = scrollLeftRef.current - (e.pageX - scrollRef.current.offsetLeft - startX.current);
  };
  const handleMouseUp = () => { isDragging.current = false; resetAutoScroll(); };

  // Touch swipe
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
    if (autoScrollRef.current) clearInterval(autoScrollRef.current);
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      const next = diff > 0
        ? Math.min(activeIndex + 1, TESTIMONIALS.length - 1)
        : Math.max(activeIndex - 1, 0);
      setActiveIndex(next);
      scrollToIndex(next);
    }
    resetAutoScroll();
  };

  return (
    <div style={{ marginBottom: 24 }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        <div style={{ width: 4, height: 20, background: '#c0007a', borderRadius: 2 }} />
        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#111827', margin: 0 }}>What Customers Say</h3>
        <span style={{
          fontSize: 10, fontWeight: 700,
          background: 'linear-gradient(90deg, #fbbf24, #f59e0b)',
          color: '#fff', borderRadius: 20, padding: '2px 8px', letterSpacing: 0.4,
        }}>★ 4.9 / 5</span>
      </div>

      {/* Slider */}
      <div
        ref={scrollRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{
          display: 'flex',
          gap: CARD_GAP,
          overflowX: 'auto',
          scrollSnapType: 'x mandatory',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          cursor: 'grab',
          paddingBottom: 4,
        }}
      >
        {TESTIMONIALS.map((t, i) => (
          <div
            key={i}
            style={{
              width: CARD_WIDTH,
              minWidth: CARD_WIDTH,
              maxWidth: CARD_WIDTH,
              scrollSnapAlign: 'start',
              flexShrink: 0,
              background: '#fff',
              borderRadius: 16,
              border: '1px solid #f3f4f6',
              boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
              padding: '16px',
              userSelect: 'none',
              overflow: 'hidden',
              boxSizing: 'border-box' as const,
            }}
          >
            {/* Avatar + Name */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
              <div style={{
                width: 48, height: 48, borderRadius: '50%',
                overflow: 'hidden', flexShrink: 0,
                border: '2px solid #c0007a',
              }}>
                {loadedImages[t.imgIdx] ? (
                  <img
                    src={loadedImages[t.imgIdx]}
                    alt={t.name}
                    draggable={false}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                ) : (
                  <div style={{ width: '100%', height: '100%', background: '#f3f4f6' }} />
                )}
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 14, color: '#111827', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {t.name}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 2 }}>
                  <svg width="10" height="10" fill="#c0007a" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  <span style={{ fontSize: 12, color: '#6b7280' }}>{t.area}</span>
                </div>
              </div>
            </div>

            {/* Stars */}
            <div style={{ display: 'flex', gap: 2, marginBottom: 8 }}>
              {Array.from({ length: t.stars }).map((_, si) => (
                <svg key={si} width="14" height="14" fill="#fbbf24" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>

            {/* Review */}
            <p style={{
              fontSize: 13, color: '#4b5563', lineHeight: 1.6, margin: 0,
              overflowWrap: 'break-word', wordBreak: 'break-word',
            }}>
              "{t.review}"
            </p>

            {/* Device tag */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginTop: 12 }}>
              <svg width="12" height="12" fill="none" stroke="#c0007a" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
              </svg>
              <span style={{ fontSize: 12, color: '#c0007a', fontWeight: 600 }}>{t.device}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Dot indicators */}
      <div style={{ display: 'flex', justifyContent: 'center', gap: 5, marginTop: 10 }}>
        {TESTIMONIALS.map((_, i) => (
          <div
            key={i}
            onClick={() => { scrollToIndex(i); setActiveIndex(i); resetAutoScroll(); }}
            style={{
              width: i === activeIndex ? 18 : 6,
              height: 6,
              borderRadius: 3,
              background: i === activeIndex ? '#c0007a' : '#d1d5db',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default TestimonialMarquee;
